export function calculateDifferentRoleExecutions(editedService, service) {
  const differenceIds = [];
  editedService.role_executions.forEach((roleEx) => {
    const originalRoleEx = service.role_executions.find((ex) => ex.role_id === roleEx.role_id);
    if (originalRoleEx) {
      if (originalRoleEx.price !== roleEx.price) {
        differenceIds.push(roleEx.id || 0);
      }
    }
  });
  return differenceIds;
}

export function sumUpFutureAppointments(futureAppoinmentsResponse) {
  const sums = {
    custom_priced: 0,
    default_priced: 0,
  };

  futureAppoinmentsResponse.forEach((result) => {
    sums.custom_priced += result.custom_priced;
    sums.default_priced += result.default_priced;
  });

  return sums;
}
